import * as React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import PageContainer from "../components/shared/PageContainer";
import TemplateUploadForm from "../components/template/TemplateUploadForm";
import TemplateUploadFormModal from "../components/template/TemplateUploadFormModal";
import { TranscoderTemplateUpload } from "../services/api";

function TemplateUpload() {
  const navigate = useNavigate();
  const [transcoderTemplate, setTranscoderTemplate] = useState<TranscoderTemplateUpload>(
    new TranscoderTemplateUpload(""),
  );
  const [open, setOpen] = React.useState(false);
  const uploadTranscoderTemplate = async () => {
    setOpen(false);
    await transcoderTemplate.create();
    navigate("/templates");
  };

  const openModal = () => {
    setOpen(true);
  };

  return (
    <PageContainer>
      <h2>Upload new Transcode Profile</h2>
      <TemplateUploadForm
        transcoderTemplate={transcoderTemplate}
        setTranscoderTemplate={setTranscoderTemplate}
        submit={openModal}
      />
      <TemplateUploadFormModal
        json={transcoderTemplate.payload}
        open={open}
        setOpen={setOpen}
        confirmSubmit={uploadTranscoderTemplate}
      />
    </PageContainer>
  );
}

export default TemplateUpload;
